// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e509bb66","667":"18b85aa4","977":"096ef918"}[chunkId] + ".chunk.js";
};